/* eslint camelcase: 0 */
import { request } from "../helpers/axios.new";

export const GET_USER_BADGE = ({ userId, badgeId }) => {
  return request({
    url: `/user-badge?userId=${userId}&badgeId=${badgeId}`,
    method: "GET",
  });
};
